import React from 'react';
import ReactMarkdown from 'react-markdown';
import { format } from 'date-fns';
import { Bot, User } from 'lucide-react';
import { ChatMessage } from '../stores/useAiChatStore';
import { AiProductCard } from './AiProductCard';

export const AiChatMessage: React.FC<{ message: ChatMessage }> = ({ message }) => {
  const isUser = message.role === 'user';
  const isError = message.role === 'error';

  return (
    <div className={`flex w-full ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div className={`flex max-w-[85%] gap-2 ${isUser ? 'flex-row-reverse' : 'flex-row'}`}>
        
        {/* Avatar */}
        <div className="flex-shrink-0 mt-1">
          {isUser ? (
            <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center">
              <User className="w-5 h-5 text-gray-500" />
            </div>
          ) : (
            <div className={`w-8 h-8 rounded-full flex items-center justify-center ${isError ? 'bg-red-100' : 'bg-primary/10'}`}>
              <Bot className={`w-5 h-5 ${isError ? 'text-red-500' : 'text-primary'}`} />
            </div>
          )}
        </div>

        {/* Message Bubble */}
        <div className="flex flex-col gap-1 min-w-0">
          <div 
            className={`px-4 py-3 rounded-2xl break-words
              ${isUser ? 'bg-primary text-white ltr:rounded-tr-sm rtl:rounded-tl-sm' : 
                isError ? 'bg-red-50 text-red-800 border border-red-100 ltr:rounded-tl-sm rtl:rounded-tr-sm' : 
                'bg-gray-100 text-text-main ltr:rounded-tl-sm rtl:rounded-tr-sm'}`}
            style={isUser ? { background: 'linear-gradient(135deg, #FFD700 0%, #B8860B 100%)', color: '#fff' } : {}}
          >
            {isUser ? (
              <p className="whitespace-pre-wrap">{message.text}</p>
            ) : (
              <div className="prose prose-sm max-w-none prose-p:leading-snug prose-ul:my-1 prose-li:my-0">
                <ReactMarkdown>{message.text}</ReactMarkdown>
              </div>
            )}
          </div>
          
          <span className={`text-[10px] text-text-muted px-1 ${isUser ? 'ltr:text-right rtl:text-left' : 'ltr:text-left rtl:text-right'}`}>
            {format(new Date(message.timestamp), 'HH:mm')}
          </span>

          {/* Product Carousel */}
          {message.products && message.products.length > 0 && (
            <div className="mt-2 flex gap-3 overflow-x-auto pb-4 snap-x snap-mandatory hide-scrollbar">
              {message.products.map((p: any) => (
                <AiProductCard key={p.id} product={p} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
